module.exports = __webpack_public_path__ + "img/birthday-girl.a5c50fb8.svg";